import React from "react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center bg-[#08080b] text-white px-6 text-center" data-testid="not-found-page">
      <div className="font-mono-alt text-[10px] tracking-widest text-white/30 uppercase mb-3">404 — Not Found</div>
      <h1 className="font-display text-3xl md:text-4xl mb-3">This page took a wrong turn</h1>
      <p className="text-white/50 text-sm max-w-md">
        The address you opened doesn&apos;t exist. Here are the places people usually need:
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <a href="/" data-testid="not-found-home"
          className="px-6 py-3 rounded-full bg-[#1F5EFF] text-white text-sm font-semibold hover:bg-white hover:text-black transition-colors">
          Home
        </a>
        <a href="/services" data-testid="not-found-services"
          className="px-6 py-3 rounded-full border border-white/15 text-sm text-white/70 hover:text-white hover:border-white/40 transition-colors">
          Services &amp; Pricing
        </a>
        <a href="/book" data-testid="not-found-book"
          className="px-6 py-3 rounded-full border border-white/15 text-sm text-white/70 hover:text-white hover:border-white/40 transition-colors">
          Book Online
        </a>
      </div>
      <a href="tel:+13683808483" className="mt-6 font-mono-alt text-[11px] tracking-widest text-white/35 hover:text-white/70 transition-colors">
        or call +1 (368) 380-8483
      </a>
    </div>
  );
}
